<mat-toolbar class="mat-elevation-z6">
  <a class="logo" routerLink="/"><img src="./assets/images/app-icon.png"></a>
  <app-main-nav *ngIf="isLoggedIn()"></app-main-nav>
  <app-user-nav></app-user-nav>
</mat-toolbar>
